"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GlobalRemoteLogRegistry {
    static getRegistry() {
        if (!window.__FMK_online_remote_log_registry__) {
            window.__FMK_online_remote_log_registry__ = new GlobalRemoteLogRegistry();
        }
        return window.__FMK_online_remote_log_registry__;
    }
    constructor() {
        this.remoteLogServices = [];
        window.addEventListener("error", event => {
            this.handleError(event);
        });
        window.addEventListener("unhandledrejection", event => {
            const reasonAsError = this.mapErrorToErrorEvent(event.reason);
            this.handleError(reasonAsError);
        });
    }
    register(remoteLogService) {
        this.remoteLogServices.push(remoteLogService);
    }
    handleError(error) {
        const foundService = this.remoteLogServices
            .find(remoteLogService => remoteLogService.getModuleContext().getModuleScriptName() === error.filename);
        if (foundService) {
            foundService.logError(error);
        }
        else if (!foundService) { // Log from boot if no module is found
            const bootRemoteLog = this.remoteLogServices
                .find(remoteLogService => remoteLogService.getModuleContext().getModuleName() === "boot");
            bootRemoteLog?.logError(error);
        }
    }
    mapErrorToErrorEvent(error) {
        const { filename, lineno, colno } = this.extractFileLineColFromStack(error.stack);
        return {
            colno: colno,
            error: error,
            filename: filename,
            lineno: lineno,
            message: error.message
        };
    }
    extractFileLineColFromStack(stack) {
        const firstLine = stack?.split("\n").find(l => this.getSourceUrlFromStackLine(l));
        return firstLine && this.getFileLineColFromStackLine(firstLine) || {
            colno: undefined,
            filename: undefined,
            lineno: undefined
        };
    }
    getSourceUrlFromStackLine(line) {
        const match = line.match(/(http|https):\/\/(\w*)(:\d+)?(.*\.js)/);
        return match && match[0];
    }
    getFileLineColFromStackLine(line) {
        const match = line.match(/((http|https):\/\/(\w*)(:\d+)?(.*\.js)(?:\?[^:]*)?):(\d+):(\d+)/);
        return match && {
            colno: match[7],
            filename: match[1],
            lineno: match[6]
        };
    }
}
exports.default = GlobalRemoteLogRegistry;
//# sourceMappingURL=GlobalRemoteLogRegistry.js.map